
import styled from 'styled-components'

export const PlusMinusButton = styled.button`
  display:flex;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  background: none;
  color: ${props => props.color} !important;
  z-index: 99 !important;
  visibility: none;
  text-align: center;
  border-radius: 50%;
  border-color: ${props => props.color} !important;
  letter-spacing: 1px;
  width:25px !important;
  height:25px !important;
  font-size: 12px;
  &:hover{
    background-color: ${props => props.color} !important;
    color: white !important;

  }
  &:active{
    background-color: ${props => props.color} !important;
    color: white !important;

  }
`
PlusMinusButton.defaultProps = {
  color: "#DAB777"
}


// WEBPACK FOOTER //
// /src/components/CounterStyle.js